import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { UserService } from '../services/user.service';

export const termsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);

  return userService.getCurrentUser().pipe(
    take(1),
    map(user => user.hasAcceptedCurrentTerms
      ? true
      : router.createUrlTree(['/legal/accept'])),
    catchError(() => of(true)),
  );
};
